import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wilkesBarreConfig } from "./data";

export default function WilkesBarrePage() {
  return <CityPageTemplate config={wilkesBarreConfig} />;
}